import { Pipe, PipeTransform } from "@angular/core";
import { NumberUtils } from "@mra/hlp9002";

@Pipe({
  name: "monnaie",
  standalone: true
})
export class MonnaiePipe implements PipeTransform {
  /**
   * formatte un montant
   * @param value montant
   * @returns montant formatté
   */
  transform(value: number | "" | undefined): string {
    if (value === "" || value === undefined) return "";
    return NumberUtils.formatterMonnaie(value);
  }
}
